import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    ADD_QUALIFICATION_TYPE: (qualificationType) => ({ qualificationType }),
    API: {
      ADD_QUALIFICATION_TYPE: apiResourceActionCreator('qualificationType')
    }
  }
})

export const apiAction = (authToken, formData) => commonApiActions.authenticated.postFormData(`${API_ENDPOINT}/qualification-type`, authToken, formData, actions.admin.api.addQualificationType);

function* addQualificationType(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, {
    data: action.payload.qualificationType,
  }));

  const result = yield apiActionResult(actions.admin.api.addQualificationType);

  if (result.success) {
    yield put(push({ pathname: routes.adminPortal.qualificationType }));
  }
}

const configuration = {
  name: 'addQualificationType',
  action: actions,
  sagas: addQualificationType,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/addQualificationType.js